export const ColorList = [
	'#7967ae', '#2ba0c9', '#7967ae', '#f2635d', '#e4a84a', '#f2635d',
	'#940a0a', '#1a8569', '#3ebede', '#89e3f9', '#ffb400', '#f47b19',
	'#cc00ff', '#51dc51', '#d40f0f', '#2adbad'
];
